import { ReactNode } from 'react';
import { SxProps, TableCell, TableCellProps } from '@mui/material';
import { Theme } from '@mui/material/styles/createTheme';
import { Typography } from '../Typography/Typography';

interface DataTableCellProps extends Omit<TableCellProps, 'sx'> {
  sx?: SxProps<Theme>;
  children: ReactNode;
}

export const DataTableCell = ({ children, align = 'left', sx, ...props }: DataTableCellProps) => (
  <TableCell
    align={align}
    sx={{
      padding: '0px 8px',
      height: '56px',

      '&:first-of-type': {
        paddingLeft: '16px',
      },

      '&:last-of-type': {
        paddingRight: '16px',
      },
      ...sx,
    }}
    {...props}
  >
    {typeof children === 'string' ? (
      <Typography fontSize="0.875rem" lineHeight="20px" overflow="hidden" textOverflow="ellipsis">
        {children}
      </Typography>
    ) : (
      children
    )}
  </TableCell>
);
